import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { CurrentCompanyStore } from '../../../../stores/CurrentCompanyStore'
import { API, IDevice } from '@getgreenline/homi-shared'
import { Modal, Button } from 'antd'
import { FormError } from '../../../../components/FormError'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  deviceUser?: IDevice
  isOpen: boolean
  onHide: () => void
}

interface State {
  isSaving?: boolean
  password: string
  confirmPassword: string
  errorMessage?: string
}

@inject('currentCompanyStore')
@observer
export class ResetPasswordModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      isSaving: false,
      password: '',
      confirmPassword: '',
      errorMessage: undefined,
    }
  }

  save() {
    if (!this.state.password) {
      return this.setState({
        errorMessage: 'You must enter a password',
      })
    }

    const company = this.props.currentCompanyStore!.company!
    this.setState({
      isSaving: true,
      errorMessage: undefined,
    })
    API.resetDevicePassword(company.id, this.props.deviceUser!.id, this.state.password)
      .then(() => {
        this.setState({ isSaving: false })
        this.onHide()
      })
      .catch((error: any) => {
        this.setState({ isSaving: false })
        this.setState({
          errorMessage: error.response.data.message || 'There was an error updating',
        })
      })
  }

  onHide() {
    this.props.onHide()
  }

  render() {
    let saveButton: JSX.Element
    if (!this.state.password) {
      saveButton = (
        <Button type='primary' disabled>
          Please enter a password
        </Button>
      )
    } else if (this.state.password !== this.state.confirmPassword) {
      saveButton = (
        <Button type='primary' disabled>
          Passwords must match
        </Button>
      )
    } else {
      saveButton = (
        <Button
          type='primary'
          loading={this.state.isSaving}
          onClick={(e) => {
            e.preventDefault()
            this.save()
          }}
        >
          Reset password
        </Button>
      )
    }

    let body: JSX.Element

    if (!this.props.deviceUser) {
      body = <div>Loading...</div>
    } else {
      body = (
        <form>
          <div className='form-group'>
            <label className='form-label'>New password</label>
            <p className='text-muted'>
              Please note that resetting your device password may log out existing sessions.
            </p>
            <input
              className='form-control'
              type='password'
              value={this.state.password}
              onChange={(e) => this.setState({ password: e.target.value })}
            />
          </div>
          <div className='form-group'>
            <label className='form-label'>Confirm password</label>
            <input
              className='form-control'
              type='password'
              value={this.state.confirmPassword}
              onChange={(e) => this.setState({ confirmPassword: e.target.value })}
            />
          </div>
          <FormError message={this.state.errorMessage} />
        </form>
      )
    }

    return (
      <Modal
        title='Reset device password'
        visible={this.props.isOpen}
        onCancel={() => this.onHide()}
        footer={[
          <Button key='cancel' onClick={() => this.onHide()}>
            Cancel
          </Button>,
          saveButton,
        ]}
      >
        {body}
      </Modal>
    )
  }
}
